module.exports = __webpack_public_path__ + "img/default.692a2683.png";